import {ReactComponent as Patrimoine} from '../img/icons/patrimoine_white.svg'
import React from 'react';

export function GetIconName(menu) {
  switch (menu) {
    case "A PROPOS": case "A propos": return 'mdiInformation'
    case "ORGANISATIONS": case "Entreprises": return 'mdiCity'
    case "COLLABORATEURS": return 'mdiAccountTie'
    case "Employés": return 'mdiAccountTie'
    case "Horaires": return 'mdiCalendarMonth'
    // case "Demandes Cong\u00e9s": return 'mdiCalendarMultiselect'
    case "Contrats": return 'mdiFileDocumentEdit'
    case "Absences": return 'mdiClockRemove'
    case "Demandes Congés": return 'mdiCalendarRemove'
    case "Pointage": return 'mdiClockCheck'
    case "Postes": return 'mdiBriefcase'
    case "Orgranigramme": return 'mdiSitemap'
    case "Banques": return 'mdiBank'
    case "Conventions": return 'mdiHumanCapacityIncrease'
    case "Signataires": return 'mdiDrawPen'
    case "REFERENTIEL": return "mdiFolderFile";
    case "Listes fichiers": return "mdiFileMultiple";
    case "Types fichiers": return "mdiFileCog";
    case "ADMIN.": return 'mdiSecurity'
    case "Mailing" : return 'mdiEmail'
    case "Privilèges": return 'mdiStarCheck'
    case "Rôles": return 'mdiAccountCog'
    case "Paramètres": return 'mdiCog'
    case "Sessions": return 'mdiAccountClock'
    case "Utilisateurs": return 'mdiAccountMultiple'
    case "PATRIMOINE": return <Patrimoine style={{height:'20px'}}/>
    case "Matériels": return 'mdiDesktopTowerMonitor'
    case "Types Matériels": return 'mdiDotsCircle'
    case "Lignes": return 'mdiSim'
    case "Moyens généraux" : return 'mdiFileCabinet'
    case "Véhicules": return 'mdiCarMultiple'
    case "Marques": return 'mdiTagMultiple'
    case "Associes": return 'mdiAccountMultiple'
    case 'close' : return 'mdiClose'
    default: return ' mdiAlertCircle'
  }

}